<mat-card fxLayoutAlign="center center" fxLayout="column" class="alert-warning">
  <mat-card-content fxLayout="row">
    <mat-icon>warning</mat-icon> &nbsp; Accès non autorisé
  </mat-card-content>
</mat-card>
